<template>
  <section class="section social-section">
    <b-row>
      <b-col md="5">
        <div class="mb-2 float-lg-left" data-aos="flip-right">
          <SocialImage class="meet-image" />
        </div>
      </b-col>

      <b-col offset-md="1" md="6">
        <ul class="list-unstyled">
          <li class="media d-block d-sm-flex">
            <div class="media-body mt-3 mt-sm-0 mt-lg-0 text-md-left">
              <h5>Join us on social media</h5>
              <p class="mt-0 mb-5">
                Follow us on
                <a
                  class="text-link"
                  href="https://www.instagram.com/unstitched.xyz/"
                  target="_blank"
                  rel="noopener noreferrer"
                  >Instagram</a
                >
                to see what we're up to and join the conversation.
              </p>
            </div>
          </li>

          <li class="media d-block d-sm-flex">
            <div class="media-body mt-3 mt-sm-0 mt-lg-0 text-md-left">
              <h5>Roadmap</h5>
              <p class="mt-0 mb-5">
                Head over to our
                <a
                  class="text-link"
                  href="https://trello.com/b/09o9xMa6/unstitched-transparent-roadmap"
                  target="_blank"
                  rel="noopener noreferrer"
                  >Roadmap</a
                >
                to see what we're working on next.
              </p>
            </div>
          </li>
        </ul>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import SocialImage from "./assets/SocialImage";

export default {
  components: {
    SocialImage
  }
};
</script>

<style lang="scss">
@import "~@/styles/_colour-palette.scss";

.social-section {
  .text-link {
    color: darken($primary-accent, 10%);
  }
  .meet-image {
    margin-top: -90px;
  }

  .display-4 {
    font-weight: 300;
    font-size: 3rem;
  }

  .accent {
    color: $primary-accent;
  }

  .sign-up {
    font-weight: 400;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/community/SocialSection.vue